export default {
  en: {
    radio_title: 'Metric',
    region_title: 'Metrics Category',
    market_title: 'Metric',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'Metric',
    button_market: 'Metric',
    search_none: 'No result found',
    country_no_data: 'No result found',
  },
  cn: {
    radio_title: '指标',
    region_title: 'Metrics Category',
    market_title: '指标',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '指标',
    button_market: '指标',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
  },
};
